<template>
  <div class="loading" v-if="loading">
    <img src="https://f.msup.com.cn/加载.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: [Boolean, Number, String],
      default: false
    }
  },
  watch: {
    loading(_new, _old) {
      console.log(_new, _old);
    }
  }
}
</script>

<style lang="scss">
.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: rgba(0, 0, 0, 0.2);
  &::before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 40;
    // background-color: var(--main-bgcolor);
    opacity: 0.05;
  }
  img {
    width: 50px;
    height: 50px;
    position: relative;
    z-index: 50;
    animation: revolve 1.3s steps(8,start) infinite;
  }
  @keyframes revolve {
    0% {
      transform: rotate(0deg);
    }
    // 50% {
    //   transform: rotate(180deg);
    // }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>